const Module = () => import('./HpModule.vue');

import { useAuthStore } from '@/stores/authStore';

const filterPath = (to, from, next) => {
  if (to.fullPath !== to.path) {
    to.meta.breadcrumb = setBreadcrumbs(to, from);
    next({ path: to.path });
  } else {
    to.meta.breadcrumb = setBreadcrumbs(to, from);
    next();
  }
};

const setBreadcrumbs = (to) => {
  let breadcrumbs = [];
  const authStore = useAuthStore();

  if (authStore.user.isAdminUser && to.name === 'hpannualreport') {
      breadcrumbs.push({ label: 'Review Annual Reports', route: '/program/annualreports' });
      breadcrumbs.push({ label: to.meta.title });
  } else {
    breadcrumbs = to.meta.breadcrumb;
  }

  return breadcrumbs;
};

const moduleRoutes = {
  path: '/hp',
  component: Module,
  children: [
      {
          path: 'annualreport/:reportId',
          name: 'hpannualreport',
          props: true,
          meta: {
              title: 'Health Plan Financial and Statistical Report',
              requiresAuth: true,
              breadcrumb: [
                  { label: 'Annual Reports', route: '/annualreports' },
                  { label: 'Health Plan Financial and Statistical Report' }
              ]
          },
          component: () => import('./views/HpAnnualReportView.vue'),
          beforeEnter: filterPath
      }
  ]
};

export default router => {
  router.addRoute(moduleRoutes);
};